import React, { useRef, useEffect } from 'react'

import { quillService } from '../../../common/services/quill.service'

import { useStyles } from './inline-editor.style'

export function InlineEditor ({ cell, showHighlight = false, isInHeaderCell = false, onSelectionChange, onTextChange }) {
  const classes = useStyles()

  const editorRef = useRef()
  const quill = useRef()

  useEffect(() => {
    quill.current = quillService.createQuillInstance(editorRef.current, buildOptions())
    if (cell.delta) {
      quill.current.setContents(cell.delta)
    }
    quill.current.on('text-change', function () {
      cell.delta = quill.current.getContents()
      onTextChange(cell)
    })
    quill.current.on('selection-change', function (delta, oldDelta) {
      let isFirstSelection = false

      if (delta !== null && oldDelta === null) {
        isFirstSelection = true
      }

      onSelectionChange(cell, isFirstSelection)
    })
  }, [])

  function buildOptions () {
    return {
      theme: 'bubble',
      modules: {
        toolbar: [
          ['bold', 'italic', 'strike', { align: [] }, { list: 'ordered' }, { list: 'bullet' }, 'link', 'formula', 'clean']
        ]
      },
      // Limit the formatting that will be allowed when copy/pasting into the editor - https://quilljs.com/docs/formats/
      // Note: 'script' is for superscript/subscript, not script tag
      formats: [ 'bold', 'italic', 'strike', 'script', 'link', 'list', 'align', 'formula' ]
    }
  }

  return (
    <>
      <div ref={editorRef}></div>
      {showHighlight && <div className={isInHeaderCell ? classes.highlightBorderHeader : classes.highlightBorder}></div>}
    </>
  )
}
